<template>
	<AdminPageLayout :loading="loading" :error="error">
		<table class="generic-table">
			<thead>
				<tr>
					<th>Email</th>
					<th>Login</th>
					<th>Password</th>
					<th>Created</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="socks in socksList" :key="socks.login">
					<td>{{ socks.email }}</td>
					<td>{{ socks.login }}</td>
					<td>{{ socks.password }}</td>
					<td>{{ $formatDate(socks.created) }}</td>
					<td>
						<div class="generic-table-actions">
							<button 
								@click="deleteSocks(socks.login)"
								class="generic-table-action-button"
								:disabled="action_loading"
							>
								Delete
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</AdminPageLayout>
</template>

<script>
import AdminPageLayout from './_PageLayout.vue'

export default {
	name: 'AdminSocks',
	components: {
		AdminPageLayout
	},
	data() {
		return {
			loading: true,
			action_loading: false,
			error: '',
			socksList: []
		}
	},
	async mounted() {
		await this.fetchSocks()
	},
	methods: {
		async fetchSocks() {
			this.loading = true
			this.error = ''

			const authToken = localStorage.getItem('authToken')?.trim()
			if (!authToken || authToken === 'null') {
				this.$router.push({ name: 'Login' })
				return
			}
			
			try {
				const response = await this.$api.post('/api/admin/socks', {
					authToken: authToken
				})
				
				this.socksList = response.data.socks || []
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else {
					this.error = 'An error occurred while loading SOCKS accounts.'
					console.error('Error:', error)
				}
			} finally {
				this.loading = false
			}
		},
		async deleteSocks(login) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/socks/delete', {
					authToken: authToken,
					login: login
				})
				await this.fetchSocks()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'SOCKS account not found.'
				} else {
					this.error = 'An error occurred while deleting SOCKS account.'
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		}
	}
}
</script>

<style scoped>
</style>

